import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { ButtonGroup, HrmEmployeeFilter, SearchBox } from "@components";
import { TableColumn } from "./TableColumn";

import { useResignations } from "@hooks/HRM/resignations/useResignations";

import { TablePagination } from "@helpers/tablePagination";

import { RESIGNATION_STATUS } from "@constants/status.hrm";
import { useForm } from "react-hook-form";

const { DRAFT, IN_PROGRESS, APPROVED, REJECTED, ACTION_NEEDED } =
  RESIGNATION_STATUS;

export const ResignationListTable = () => {
  const [activeStatus, setActiveStatus] = useState(0);

  const { t } = useTranslation();

  const { control, register, setValue } = useForm();

  const { resignations, pagination, handleQuery } = useResignations();

  const modifiedData = resignations?.map((resignation: any) => ({
    employeeID: resignation.employee.id,
    resignationID: resignation?.id,
    ...resignation.employee,
    ...resignation,
  }));

  const filterButtons = t("LEAVE_LIST.TABLE.ACTION_BUTTONS", {
    returnObjects: true,
  }) as string[];

  const btnGroupAction = (index: number) => {
    let statusId = null;
    setActiveStatus(index);

    switch (index) {
      case 0:
        statusId = null;
        break;
      case 1:
        statusId = DRAFT;
        break;
      case 2:
        statusId = IN_PROGRESS;
        break;
      case 3:
        statusId = APPROVED;
        break;
      case 4:
        statusId = REJECTED;
        break;
      case 5:
        statusId = ACTION_NEEDED;
        break;
      default:
        statusId = null;
        break;
    }
    handleQuery("status", statusId);
  };

  return (
    <div>
      <HrmEmployeeFilter
        handleQuery={handleQuery}
        control={control}
        register={register}
        setValue={setValue}
      />

      <Table
        header={{
          title: t("RESIGNATIONS.TABLE.HEADER"),
          badge: {
            label: `${pagination?.total || 0}`,
            size: "sm",
            type: "primary",
          },
        }}
        headerExtension={{
          leftComponents: [
            <ButtonGroup
              key="btn-group"
              btnGroupData={filterButtons}
              activeState={activeStatus}
              action={btnGroupAction}
            />,
          ],
          rightComponents: [
            <div className="row mt-3">
              <SearchBox
                key="search"
                control={control}
                handleQuery={handleQuery}
              />
            </div>,
          ],
        }}
        columns={TableColumn(t)}
        rows={modifiedData}
        pagination={TablePagination(pagination, handleQuery)}
      />
    </div>
  );
};
